import { useState, useEffect, useCallback } from 'react';
import { useNotifications } from '../../../hooks/useNotifications';
import { HeadquartersService } from '../../../services/headquartersService';

export const useHeadquarterSelector = () => {
  const { showErrorNotification } = useNotifications();
  const [headquarters, setHeadquarters] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchHeadquarters = useCallback(async () => {
    setIsLoading(true);
    try {
      const { headquarters: fetchedHeadquarters } = await HeadquartersService.getHeadquarters({});
      setHeadquarters(fetchedHeadquarters);
    } catch {
      showErrorNotification({ title: 'error', description: 'errorRetrievingRecords' });
    } finally {
      setIsLoading(false);
    }
  }, [showErrorNotification]);

  useEffect(() => {
    fetchHeadquarters();
  }, [fetchHeadquarters]);

  return { headquarters, isLoading };
};
